// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"860":"mobileHome","953":"pcHome"}[chunkId] || chunkId) + "." + {"615":"da62aae3","860":"10e2002c","953":"e5ac2d03"}[chunkId] + ".js";
};